<template>
  <section id="conversation">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="cardActions"
          title="Spider Jobs - Resultado de teste"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="getJobTest"
        >
          <b-row>
            <b-col cols="12">
              <b-table
                :busy="isLoading"
                responsive
                :items="results"
                :fields="result_fields"
                show-empty
                sort-icon-left
                no-local-sorting
                :sort-by.sync="filtersValues.sortBy"
                :sort-desc.sync="filtersValues.sortDesc"
                @sort-changed="sortingChanged"
              >
                <template #empty>
                  <h4 class="text-center mt-2 mb-2">
                    Nenhum resultado encontrado
                  </h4>
                </template>

                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>

              </b-table>
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>

  </section>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserService from '@/services/userService'
import SpiderJobService from '@/services/spiderJobService'
import toast from '@/mixins/toast'
import { formatDateTimeDbToView } from '@/utils/helpers'
import {
  BRow,
  BCol,
  BTable,
  BSpinner,
  BBreadcrumb,
} from 'bootstrap-vue'

export default {
  components: {
    BCardActions,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BBreadcrumb,
  },
  mixins: [toast],
  data() {
    return {
      userService: null,
      isLoading: false,
      isSubmited: false,
      cardData: {},
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas - Spider Jobs',
          to: { name: 'cms-tools-spider' },
        },
        {
          text: 'Testando Job',
          active: true,
        },
      ],

      filtersInitialValues: {},
      filtersValues: {
        emails: '',
        type: 'all',
        status: 'all',
        sortBy: 'id',
        sortDesc: true,
      },

      results: [],
      result_fields: [],
      formatDateTimeDbToView,
      preventCloseModal: false,
      dataAssignKanban: null,
      dataKanbanAdditional: null,
    }
  },
  computed: {
    variant() {
      return document.body.classList.contains('dark-layout') ? 'dark' : undefined
    },
  },

  watch: {
  },

  created() {
    this.userService = new UserService()
    this.filtersInitialValues = { ...this.filtersValues }

    this.result_fields = [
      { key: 'name', label: 'Nome', sortable: false },
      { key: 'tags', label: 'Tags', sortable: false },
    ]

    this.getJobTest()
  },

  methods: {
    handleCtrlEnter(e) {
      if (e.ctrlKey) {
        this.getJobTest()
      }
    },

    removeJob(id) {
      this.$swal({
        title: 'Deletar job?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isRemoving = true
          this.$refs.cardActions.showLoading = true

          await SpiderJobService.deleteJob(id)
          this.results = this.results.filter(f => f.id !== id)
        }
      }).finally(() => {
        this.isRemoving = false
        this.$refs.cardActions.showLoading = false
      })
    },

    getJobTest() {
      this.isLoading = true
      SpiderJobService.test(this.$route.params.id).then(response => {
        this.results = response.data.data.jobs
      }).finally(() => {
        this.isLoading = false
        this.$refs.cardActions.showLoading = false
      })
    },

    newJob() {
      this.$router.push({ name: 'cms-tools-spider-edit', params: { id: 0 } })
    },

    reset() {
      this.filtersValues = JSON.parse(JSON.stringify(this.filtersInitialValues))
      this.results = []
      this.isSubmited = false
    },

    sortingChanged(ctx) {
      this.filtersValues.sortBy = ctx.sortBy
      this.filtersValues.sortDesc = ctx.sortDesc
      this.getJobTest()
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
